;(() => {
  'use strict'

  const GLOBAL_KEY = 'AlborJournalArticleProgress'

  const BAR_SELECTOR = '[data-ak-article-progress]'

  const VALUE_SELECTOR = '[data-ak-article-progress-value]'

  const SCOPE_SELECTOR = '[data-ak-article-progress-scope]'

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].init(document)
    return
  }

  const instances = new WeakMap()

  class ArticleProgress {
    constructor(bar) {
      this.bar = bar
      this.value = bar.querySelector(VALUE_SELECTOR)

      this.section = bar.closest('.shopify-section')

      this.scope = this.section
        ? this.section.querySelector(SCOPE_SELECTOR)
        : document.querySelector(SCOPE_SELECTOR)

      this.ticking = false
      this.resizeObserver = null

      this.handleViewportChange = this.handleViewportChange.bind(this)

      this.update = this.update.bind(this)

      if (!this.scope || !this.value) {
        return
      }

      window.addEventListener('scroll', this.handleViewportChange, { passive: true })

      window.addEventListener('resize', this.handleViewportChange, { passive: true })

      window.addEventListener('pageshow', this.handleViewportChange, { passive: true })

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.handleViewportChange)

        this.resizeObserver.observe(this.scope)
      }

      this.update()
    }

    handleViewportChange() {
      if (this.ticking) {
        return
      }

      this.ticking = true

      window.requestAnimationFrame(this.update)
    }

    update() {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight

      const scrollTop =
        window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0

      const bounds = this.scope.getBoundingClientRect()

      const scopeTop = scrollTop + bounds.top

      const scopeHeight = this.scope.offsetHeight

      const scopeEnd = scopeTop + scopeHeight - viewportHeight

      let progress = 0

      if (scopeHeight <= viewportHeight) {
        progress = scrollTop >= scopeTop ? 1 : 0
      } else {
        const availableDistance = Math.max(1, scopeEnd - scopeTop)

        progress = (scrollTop - scopeTop) / availableDistance

        progress = Math.min(1, Math.max(0, progress))
      }

      this.value.style.transform = `scaleX(${progress})`

      this.bar.setAttribute('aria-valuenow', String(Math.round(progress * 100)))

      this.ticking = false
    }

    destroy() {
      window.removeEventListener('scroll', this.handleViewportChange)

      window.removeEventListener('resize', this.handleViewportChange)

      window.removeEventListener('pageshow', this.handleViewportChange)

      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
      }

      instances.delete(this.bar)
    }
  }

  function findBars(scope) {
    const bars = []

    if (scope instanceof Element && scope.matches(BAR_SELECTOR)) {
      bars.push(scope)
    }

    if (scope.querySelectorAll) {
      bars.push(...scope.querySelectorAll(BAR_SELECTOR))
    }

    return bars
  }

  function init(scope = document) {
    findBars(scope).forEach((bar) => {
      if (instances.has(bar)) {
        return
      }

      const instance = new ArticleProgress(bar)

      instances.set(bar, instance)
    })
  }

  function destroy(scope) {
    findBars(scope).forEach((bar) => {
      const instance = instances.get(bar)

      if (instance) {
        instance.destroy()
      }
    })
  }

  window[GLOBAL_KEY] = {
    init,
    destroy
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document))
  } else {
    init(document)
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target))

  document.addEventListener('shopify:section:unload', (event) => destroy(event.target))
})()
